import IMask from 'imask';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.br';
import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.min.css';
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import 'jquery-mask-plugin';

function defineCleave(ev, options) {
  let $el = ev.currentTarget;

  if (!!$el.dataset.cleaveLoaded)
    return;

  new Cleave($el, options);
  $el.dataset.cleaveLoaded = true;
}

function defineMask($el, options) {
  if (!!$el.dataset.iMaskLoaded)
    return;

  IMask($el, options);
  $el.dataset.iMaskLoaded = true;
}

export function maskTime() {
  $('body').on('focus', '.mask-time, .time-mask', (ev) => {
    defineCleave(ev, {
      numericOnly: true,
      blocks: [2, 2],
      delimiters: [":"]
    });
  });
}

export function maskPhone() {
  $('body').on('focus', '.mask-phone', (ev) => {
    defineMask(ev.currentTarget, {
      mask: '(00) 00000-0000',
      dispatch: null
    });
  });
}

export function maskCpf() {
  $('body').on('focus', '.mask-cpf', (ev) => {
    defineCleave(ev, {
      numericOnly: true,
      blocks: [3, 3, 3, 2],
      delimiters: [".", ".", "-"]
    });
  });
}

export function maskNif() {}

// Paraguay RUC: variable-length numeric base + hyphen before the final check digit (e.g. 80170229-1).
// Cleave uses left-anchored fixed blocks, so it cannot place a delimiter before the last digit of a
// variable-length value. A manual input handler reformats on every keystroke instead.
export function maskRuc() {
  $('body').on('input', '.mask-ruc', (ev) => {
    const field = ev.target;
    const digits = field.value.replace(/\D/g, '');
    const wasAtEnd = field.selectionStart === field.value.length;

    field.value = digits.length > 1 ? `${digits.slice(0, -1)}-${digits.slice(-1)}` : digits;

    if (wasAtEnd) {
      field.setSelectionRange(field.value.length, field.value.length);
    }
  });
}

export function maskCnpj() {
  $('body').on('focus', '.mask-cnpj', (ev) => {
    defineCleave(ev, {
      numericOnly: true,
      blocks: [2, 3, 3, 4, 2],
      delimiters: [".", ".", "/", "-"]
    });
  });
}

export function maskPostalCode() {
  $(document).on('focus', '.mask-postal-code', (ev) => {
    defineCleave(ev, {
      blocks: [5, 3],
      phoneRegionCode: 'BR',
      delimiters: ["-"]
    });
  });
}

export function withDatePicker() {
  let handler = ($el) => {
    if (!!$el.dataset.flatpickr)
      return;

    flatpickr($el, {
      "dateFormat": ($el.dataset.format || "d/m/Y"),
      "altFormat": ($el.dataset.altFormat || "F j, Y"),
      "altInput": !!$el.dataset.altFormat,
      "locale": Portuguese,
      "disableMobile": true,
      "allowInput": ($el.dataset.allowInput || true),
      "maxDate": ($el.dataset.maxDate || null),
      "time_24hr": true
    });

    $el.dataset.flatpickr = true;
  }

  $('.with-date-picker').each((_, $el) => handler($el));
  $('body').on('focus', '.with-date-picker', (ev) => handler(ev.currentTarget));
}

export function withDateTimePicker() {
  let handler = (ev) => {
    let $el = ev.currentTarget;

    if (window.matchMedia("(max-width: 576px)").matches) {
      $el.setAttribute('type', 'datetime-local');
      return;
    } else {
      $el.setAttribute('type', 'text');
    }

    if (!!$el.dataset.flatpickr)
      return;

    flatpickr($el, {
      "enableTime": true,
      "dateFormat": ($el.dataset.format || "d/m/Y H:i:S"),
      "altFormat": ($el.dataset.altFormat || "F j, Y"),
      "altInput": !!$el.dataset.altFormat,
      "locale": Portuguese,
      "allowInput": ($el.dataset.allowInput || true),
      "time_24hr": true
    });

    $el.dataset.flatpickr = true;
  }
  $('body').on('focus', '.with-date-time-picker', handler);
}

export function maskMoney() {
  $(document).on('focus', '.money-mask, .decimal-mask', function(ev) {
    !this.dataset.masked && $(this).mask('000.000.000.000.000,00', { reverse: true });
    this.dataset.masked = true;
  });

  $(document).on('focus', '.numeric, .numeric-mask', (ev) => {
    if (window.matchMedia("(max-width: 576px)").matches) {
      ev.currentTarget.setAttribute('type', 'number');
    } else {
      defineCleave(ev, {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalMark: ',',
        delimiter: '.'
      });
    }
  });
}

$(document).on('click', '[data-clear-flatpickr-target]', (ev) => {
  ev.preventDefault();
  let target = document.querySelector(ev.target.dataset.clearFlatpickrTarget),
    flatpickr = target._flatpickr;

  if (!!flatpickr)
    return flatpickr.clear();

  target.value = '';
});

export default class Masks {
  static define() {
    maskTime();
    maskPhone();
    maskCpf();
    maskNif();
    maskRuc();
    maskCnpj();
    maskPostalCode();
    withDatePicker();
    withDateTimePicker();
    maskMoney();
  }
}
